import { useWeeklyUsage } from '../hooks';

/**
 * WeeklyUsageCard - Card de uso semanal
 *
 * Exibe gráfico de barras com uso de tokens por dia da semana
 * Migrado para Tailwind CSS v4
 */
export const WeeklyUsageCard = () => {
  // Fetch real weekly usage data from API
  const { weeklyData: data } = useWeeklyUsage();

  const weeklyData = data?.currentWeek || [];
  const currentWeekTotal = data?.currentWeekTotal || 0;
  const percentageChange = data?.percentageChange || 0;
  const isPositive = percentageChange > 0;

  // Find max value for scaling
  const maxValue = Math.max(...weeklyData.map(d => d.value), 1); // Min 1 to avoid division by zero

  return (
    <div className="bg-[#2a2a2a] rounded-xl p-6 border border-[#333333] hover:border-[#F4CC04] transition-all duration-400">
      {/* Header */}
      <div className="flex items-center justify-between mb-6">
        <div className="text-sm font-medium text-[#CCCCCC] m-0">Uso Semanal</div>
        <div className="flex items-center gap-1.5 px-2.5 py-1 bg-[#1a1a1a] rounded-md">
          <svg
            className={`w-3.5 h-3.5 ${isPositive ? 'text-[#f59e0b]' : 'text-[#10b981]'}`}
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            {isPositive ? (
              <path fillRule="evenodd" d="M5.293 9.707a1 1 0 010-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 01-1.414 1.414L11 7.414V15a1 1 0 11-2 0V7.414L6.707 9.707a1 1 0 01-1.414 0z" clipRule="evenodd" />
            ) : (
              <path fillRule="evenodd" d="M14.707 10.293a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 111.414-1.414L9 12.586V5a1 1 0 012 0v7.586l2.293-2.293a1 1 0 011.414 0z" clipRule="evenodd" />
            )}
          </svg>
          <span className={`text-xs font-semibold ${isPositive ? 'text-[#f59e0b]' : 'text-[#10b981]'}`}>
            {isPositive ? '+' : ''}{percentageChange}%
          </span>
        </div>
      </div>

      {/* Main Value */}
      <div className="mb-6">
        <div className="flex items-baseline gap-2 m-0">
          <span className="text-3xl font-bold text-white m-0">
            {currentWeekTotal.toLocaleString('pt-BR')}
          </span>
          <span className="text-sm text-[#666666] m-0">tokens</span>
        </div>
      </div>

      {/* Bar Chart */}
      <div className="flex items-end justify-between gap-2 h-24">
        {weeklyData.map((day) => {
          const heightPercentage = (day.value / maxValue) * 100;
          // Highlight day with max value
          const isHighlight = day.value === maxValue && maxValue > 0;

          return (
            <div key={day.day} className="flex flex-col items-center gap-2 flex-1 group">
              {/* Bar */}
              <div className="relative w-full h-24 flex items-end justify-center">
                <div
                  className={`w-full rounded-t-md transition-all duration-500 ${
                    isHighlight ? 'bg-[#F4CC04]' : 'bg-[#4a4a4a] group-hover:bg-[#5a5a5a]'
                  }`}
                  style={{ height: `${heightPercentage}%` }}
                >
                  {/* Tooltip on hover */}
                  <div className="opacity-0 group-hover:opacity-100 transition-opacity absolute -top-10 left-1/2 transform -translate-x-1/2 bg-[#1a1a1a] px-2 py-1 rounded text-xs text-white whitespace-nowrap pointer-events-none">
                    {day.value.toLocaleString('pt-BR')}
                  </div>
                </div>
              </div>
              {/* Label */}
              <span className={`text-xs ${isHighlight ? 'text-[#F4CC04] font-semibold' : 'text-[#666666]'}`}>
                {day.day}
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
